export enum SpicyLevel {
  noHeat = 0,
  mild = 1,
  medium = 2,
  hot = 3,
}
